import { useValidationContext } from "@features/mx/validations/context";
import { useSearchParams } from "react-router-dom";
import PassReadingList from "./PassReadingList";
import ValidationDetailsView from "../../shared/ValidationDetailsView";
function PassLanding() {
  const [searchParams ] = useSearchParams();
  const { viewMode, readingId, validatorId } = useValidationContext();
  return viewMode === "detail" ? (
    <ValidationDetailsView readingId={readingId}/>
  ) : (
    <PassReadingList />
  );
}

export default PassLanding;
